import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL, NAME } from './constants';
import Edit from './Edit.vue';
import List from './List.vue';

export const router = new Path(NAME, { List, Edit }, CRUMB_LABEL);
